import { createStore } from 'vuex';
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state: {
    contractNumber: "",
    typeAttendance: "",
    technicianLogin: "",
    osNumbers: "",
    addressCity: "",
    technicianName: "",
    numberPhone: "",
    accredited: "",
    osDescription: "",
    epoName: "",
    team: "",
    isLeader: false,
    userData: Object,
  },
  mutations: {
    setContractGlobal(state, payload) {
      state.contractNumber = payload
    },
    setTypeAttendance(state, payload){
      state.typeAttendance = payload
    },
    setTechnicianLogin(state, payload){
      state.technicianLogin = payload
    },
    setTechnicianName(state, payload){
      state.technicianName = payload
    },
    setNumeroOS(state, payload){
      state.osNumbers = payload
    },
    setAddressCity(state, payload){
      state.addressCity = payload
    },
    setNumberPhone(state, payload){
      state.numberPhone = payload
    },
    setAccredited(state, payload){
      state.accredited = payload
    },
    setOsDescription(state, payload){
      state.osDescription = payload
    },
    setEpoName(state, payload){
      state.epoName = payload
    },
    setTeam(state, payload){
      state.team = payload
    },
    setIsLeader(state, payload){
      state.isLeader = payload
    },
    setUserData(state, payload){
      state.userData = payload
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [
    createPersistedState()
  ],
})
